import React, { FC, useMemo } from 'react';
import { Chip, Stack, Typography } from '@mui/material';

import { TestSessionSummaryDTO } from '@/api/generated';
import CameraIcon from '@/assets/icons/camera.svg?react';
import EvaluationChip from '@/components/EvaluationChip';
import { borders } from '@/theme/constants';

import { AI_ANALYSIS_STATUSES, TEST_SESSION_STATUSES } from './options';

interface TestSessionSummaryProps {
  summary?: TestSessionSummaryDTO;
}

const TestSessionSummary: FC<TestSessionSummaryProps> = ({ summary }) => {
  const { status, isWebcamEnabled, aiAnalysisStatus, testDefinition, evaluation, isAiAnalysisEnabled } = summary ?? {};

  const statusIcon = useMemo(() => {
    const iconComponent = TEST_SESSION_STATUSES.find(({ value }) => value === status);

    return iconComponent?.Icon?.();
  }, [status]);

  const aiStatusIcon = useMemo(() => {
    const iconComponent = AI_ANALYSIS_STATUSES.find(({ value }) => value === aiAnalysisStatus);

    return iconComponent?.Icon?.();
  }, [aiAnalysisStatus]);

  if (!summary) return null;

  return (
    <Chip
      sx={{ borderRadius: 3.5, height: 28, bgcolor: 'grey.100', border: borders.half, borderColor: 'grey.500' }}
      label={
        <Stack direction="row" alignItems="center" gap={1}>
          {statusIcon}
          <Typography variant="body3">{testDefinition?.name}</Typography>
          <EvaluationChip evaluation={evaluation} />
          {isWebcamEnabled && <CameraIcon />}
          {isAiAnalysisEnabled && aiAnalysisStatus && aiStatusIcon}
        </Stack>
      }
    />
  );
};

export default TestSessionSummary;
